"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolHelper = void 0;
var sdk_1 = require("@uniswap/sdk");
var ethers_1 = require("ethers");
var utils_1 = require("ethers/lib/utils");
var subgraph_1 = require("./subgraph");
var provider_1 = require("./utils/provider");
var bmath_1 = require("./bmath");
var multicall_1 = require("./multicall");
var bignumber_1 = require("./utils/bignumber");
var uniswap_1 = require("./utils/uniswap");
var constants_1 = require("./constants");
var IERC20ABI = require('./abi/IERC20.json');
var PoolHelper = /** @class */ (function () {
    function PoolHelper(provider, network, pool, userAddress) {
        this.network = network;
        this.pool = pool;
        this.userAddress = userAddress;
        this.userAllowances = {};
        this.userBalances = {};
        this.provider = provider_1.toProvider(provider);
        this.lastUpdate = new Date().getTime();
        this.waitForUpdate = this.update();
        this.lastUpdateUniswap = new Date().getTime();
        this.waitForUniswapUpdate = this.updateUniswap();
        this.pool.exitFee = bignumber_1.toBN(0.005).times(bmath_1.BONE);
    }
    PoolHelper.prototype.updateUniswap = function () {
        return __awaiter(this, void 0, void 0, function () {
            var weth, pool, pair;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastUpdateUniswap = new Date().getTime();
                        weth = uniswap_1.getUniswapWethType(this.network);
                        pool = this.uniswapPoolTokenType;
                        return [4 /*yield*/, uniswap_1.getPair(this.provider, weth, pool)];
                    case 1:
                        pair = _a.sent();
                        if (!pair) return [3 /*break*/, 3];
                        this.ethUniswapPair = pair;
                        if (!this.userAddress) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([
                                this.provider.getBalance(this.userAddress).then(function (b) { return _this.ethBalance = bignumber_1.toBN(b); }),
                                new ethers_1.Contract(this.pool.address, IERC20ABI, this.provider).allowance(this.userAddress, constants_1.UNISWAP_ROUTER).then(function (a) { return _this.allowanceUniswapRouter = bignumber_1.toBN(a); })
                            ])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PoolHelper.prototype.getUniswapOut = function (tokenIn, amountIn, slippage) {
        if (slippage === void 0) { slippage = 2; }
        return __awaiter(this, void 0, void 0, function () {
            var pair, isPoolToken, input, amt, amountOut, bnAmount, bnAmountMin, approvalNeeded, displayAmountOut, displayAmountIn, price;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitForUniswapUpdate];
                    case 1:
                        _a.sent();
                        pair = this.ethUniswapPair;
                        if (!pair)
                            return [2 /*return*/, null];
                        isPoolToken = tokenIn.toLowerCase() == this.address.toLowerCase();
                        input = isPoolToken ? this.uniswapPoolTokenType : uniswap_1.getUniswapWethType(this.network);
                        amt = new sdk_1.TokenAmount(input, bignumber_1.toBN(amountIn).toString(10));
                        amountOut = pair.getOutputAmount(amt);
                        bnAmount = bignumber_1.toBN(uniswap_1.bigintToHex(amountOut[0].raw));
                        bnAmountMin = bnAmount.times(100 - slippage).div(100);
                        approvalNeeded = false;
                        if (this.userAddress) {
                            if (isPoolToken && this.allowanceUniswapRouter.lt(bignumber_1.toBN(amountIn))) {
                                approvalNeeded = true;
                            }
                        }
                        displayAmountOut = bignumber_1.formatBalance(bnAmountMin, 18, 4);
                        displayAmountIn = bignumber_1.formatBalance(bignumber_1.toBN(amountIn), 18, 4);
                        price = parseFloat(displayAmountOut) / parseFloat(displayAmountIn);
                        return [2 /*return*/, {
                                approvalNeeded: approvalNeeded,
                                amountOut: bignumber_1.toHex(bnAmountMin),
                                displayAmountOut: displayAmountOut,
                                price: price
                            }];
                }
            });
        });
    };
    PoolHelper.prototype.getUniswapIn = function (tokenOut, amountOut, slippage) {
        if (slippage === void 0) { slippage = 2; }
        return __awaiter(this, void 0, void 0, function () {
            var pair, isPoolToken, output, amt, amountIn, bnAmount, maxBnAmount, approvalNeeded, displayAmountOut, displayAmountIn, price;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitForUniswapUpdate];
                    case 1:
                        _a.sent();
                        pair = this.ethUniswapPair;
                        if (!pair)
                            return [2 /*return*/, null];
                        isPoolToken = tokenOut.toLowerCase() == this.address.toLowerCase();
                        output = isPoolToken ? this.uniswapPoolTokenType : uniswap_1.getUniswapWethType(this.network);
                        amt = new sdk_1.TokenAmount(output, bignumber_1.toBN(amountOut).toString(10));
                        amountIn = pair.getInputAmount(amt);
                        bnAmount = bignumber_1.toBN(uniswap_1.bigintToHex(amountIn[0].raw));
                        maxBnAmount = bnAmount.times(100 + slippage).div(100);
                        approvalNeeded = false;
                        if (this.userAddress) {
                            if (!isPoolToken && this.allowanceUniswapRouter.lt(maxBnAmount)) {
                                approvalNeeded = true;
                            }
                        }
                        displayAmountOut = bignumber_1.formatBalance(bignumber_1.toBN(amountOut), 18, 4);
                        displayAmountIn = bignumber_1.formatBalance(maxBnAmount, 18, 4);
                        price = parseFloat(displayAmountOut) / parseFloat(displayAmountIn);
                        return [2 /*return*/, {
                                approvalNeeded: approvalNeeded,
                                amountIn: bignumber_1.toHex(maxBnAmount),
                                displayAmountIn: displayAmountIn,
                                price: price
                            }];
                }
            });
        });
    };
    Object.defineProperty(PoolHelper.prototype, "chainID", {
        get: function () {
            return this.network === 'mainnet' ? 1 : 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "uniswapPoolTokenType", {
        get: function () {
            return new sdk_1.Token(this.chainID, utils_1.getAddress(this.address), 18, this.symbol, this.name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "initializer", {
        get: function () {
            return this.pool.initializer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "category", {
        get: function () {
            return this.pool.category;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "name", {
        get: function () {
            return this.pool.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "symbol", {
        get: function () {
            return this.pool.symbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "address", {
        get: function () {
            return this.pool.address;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "tokens", {
        get: function () {
            return this.pool.tokens;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PoolHelper.prototype, "shouldUpdate", {
        get: function () {
            var timestamp = Math.floor(+new Date() / 1000);
            return (timestamp - this.lastUpdate) > 120;
        },
        enumerable: false,
        configurable: true
    });
    PoolHelper.prototype.extrapolateValue = function (token) {
        var _a = this.getTokenByAddress(token), usedBalance = _a.usedBalance, usedDenorm = _a.usedDenorm;
        var totalWeight = this.pool.totalWeight;
        return usedBalance.times(totalWeight).div(usedDenorm);
    };
    Object.defineProperty(PoolHelper.prototype, "totalValueLocked", {
        get: function () {
            var tvl = 0;
            for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
                var token = _a[_i];
                var balance = parseFloat(bignumber_1.formatBalance(token.balance, 18, 10));
                var value = balance * token.priceUSD;
                tvl += value;
            }
            return tvl;
        },
        enumerable: false,
        configurable: true
    });
    PoolHelper.prototype.getSnapshots = function (days) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, subgraph_1.getPoolSnapshots(this.network, this.address, days)];
            });
        });
    };
    PoolHelper.prototype.getUserTokenData = function (address, amount) {
        if (!this.userAddress)
            return {};
        var allowance = this.userAllowances[address];
        if (allowance.gte(amount))
            return {
                remainingApprovalAmount: '0x0',
                allowance: '0x0',
                balance: '0x0'
            };
        var remainingApprovalAmount = amount.minus(allowance);
        return {
            remainingApprovalAmount: bignumber_1.toHex(remainingApprovalAmount),
            allowance: bignumber_1.toHex(allowance),
            balance: bignumber_1.toHex(this.userBalances[address])
        };
    };
    PoolHelper.prototype.setUserAddress = function (userAddress) {
        this.userAddress = userAddress;
        this.waitForUpdate = this.update();
        this.waitForUniswapUpdate = this.updateUniswap();
    };
    PoolHelper.prototype.updatePool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userBalance, totalWeight, totalSupply, swapFee, tokens, i, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, multicall_1.getCurrentPoolData(this.provider, this.pool.address, this.tokens, this.userAddress)];
                    case 1:
                        _a = _b.sent(), userBalance = _a.userBalance, totalWeight = _a.totalWeight, totalSupply = _a.totalSupply, swapFee = _a.swapFee, tokens = _a.tokens;
                        this.userPoolBalance = userBalance;
                        this.pool.totalSupply = totalSupply;
                        this.pool.totalWeight = totalWeight;
                        this.pool.swapFee = swapFee;
                        for (i = 0; i < tokens.length; i++) {
                            token = this.pool.tokens[i];
                            token.balance = tokens[i].balance;
                            token.usedBalance = tokens[i].usedBalance;
                            token.usedDenorm = tokens[i].usedDenorm;
                            token.usedWeight = tokens[i].usedWeight;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolHelper.prototype.updateUserData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, tokenDatas;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.userAddress)
                            return [2 /*return*/];
                        tokens = this.tokens;
                        return [4 /*yield*/, multicall_1.getTokenUserData(this.provider, this.userAddress, this.pool.address, tokens)];
                    case 1:
                        tokenDatas = _a.sent();
                        tokenDatas.forEach(function (_a, i) {
                            var allowance = _a.allowance, balance = _a.balance;
                            var address = tokens[i].address;
                            _this.userAllowances[address] = allowance;
                            _this.userBalances[address] = balance;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolHelper.prototype.updateSnapshotAndPrices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, snapshot, tokenPrices, lastSnapshot;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, subgraph_1.getPoolUpdate(this.network, this.address)];
                    case 1:
                        _a = _b.sent(), snapshot = _a.snapshot, tokenPrices = _a.tokenPrices;
                        lastSnapshot = this.pool.snapshots[this.pool.snapshots.length - 1];
                        if (lastSnapshot.date == snapshot.date) {
                            this.pool.snapshots[this.pool.snapshots.length - 1] = snapshot;
                        }
                        else {
                            this.pool.snapshots.push(lastSnapshot);
                        }
                        Object.keys(tokenPrices).map(function (address) {
                            var token = _this.getTokenByAddress(address);
                            token.priceUSD = tokenPrices[address];
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolHelper.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastUpdate = Math.floor(+new Date() / 1000);
                        return [4 /*yield*/, Promise.all([this.updatePool(), this.updateUserData(), this.updateSnapshotAndPrices()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PoolHelper.prototype.getTokenBySymbol = function (symbol) {
        for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
            var token = _a[_i];
            if (token.symbol.toLowerCase() == symbol.toLowerCase()) {
                return token;
            }
        }
        throw new Error("Token with symbol " + symbol + " not found in pool.");
    };
    PoolHelper.prototype.getTokenByAddress = function (address) {
        for (var _i = 0, _a = this.tokens; _i < _a.length; _i++) {
            var token = _a[_i];
            if (token.address.toLowerCase() == address.toLowerCase()) {
                return token;
            }
        }
        throw new Error("Token with address " + address + " not found in pool.");
    };
    /**
     * Calculate the amount of a specific token that must be provided to mint a given amount of pool tokens.
     *
     * @param address Address of the token to provide
     * @param poolTokensToMint Amount of pool tokens to mint
     */
    PoolHelper.prototype.calcSingleInGivenPoolOut = function (address, poolTokensToMint) {
        return __awaiter(this, void 0, void 0, function () {
            var token, amountIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        token = this.getTokenByAddress(address);
                        amountIn = bmath_1.calcSingleInGivenPoolOut(token.usedBalance, token.usedDenorm, this.pool.totalSupply, this.pool.totalWeight, bmath_1.bnum(poolTokensToMint), this.pool.swapFee);
                        return [2 /*return*/, __assign({ address: address, symbol: token.symbol, amount: bignumber_1.toHex(amountIn), decimals: token.decimals, displayAmount: bignumber_1.formatBalance(amountIn, token.decimals, 4) }, this.getUserTokenData(address, amountIn))];
                }
            });
        });
    };
    /**
     * Calculate the amount of pool tokens that can be minted by providing a given amount of a specific token.
     *
     * @param address Address of the token to provide
     * @param tokenAmountIn Amount of tokens to provide
     */
    PoolHelper.prototype.calcPoolOutGivenSingleIn = function (address, tokenAmountIn) {
        return __awaiter(this, void 0, void 0, function () {
            var amountIn, token, poolAmountOut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        amountIn = bmath_1.bnum(tokenAmountIn);
                        token = this.getTokenByAddress(address);
                        poolAmountOut = bmath_1.calcPoolOutGivenSingleIn(token.usedBalance, token.usedDenorm, this.pool.totalSupply, this.pool.totalWeight, amountIn, this.pool.swapFee);
                        return [2 /*return*/, __assign({ address: address, symbol: token.symbol, amount: bignumber_1.toHex(poolAmountOut), decimals: token.decimals, displayAmount: bignumber_1.formatBalance(poolAmountOut, token.decimals, 4) }, this.getUserTokenData(address, amountIn))];
                }
            });
        });
    };
    /**
     * Calculate the amount of each underlying token that must be provided to mint a given amount of pool tokens.
     *
     * @param poolTokensToMint Amount of pool tokens to mint
     */
    PoolHelper.prototype.calcAllInGivenPoolOut = function (poolTokensToMint) {
        return __awaiter(this, void 0, void 0, function () {
            var usedBalances, partials, _i, _a, token, symbol, address, decimals, usedBalance, poolAmountOut, amounts;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _b.sent();
                        usedBalances = [];
                        partials = [];
                        for (_i = 0, _a = this.tokens; _i < _a.length; _i++) {
                            token = _a[_i];
                            symbol = token.symbol, address = token.address, decimals = token.decimals, usedBalance = token.usedBalance;
                            partials.push(Object.assign({}, { symbol: symbol, address: address, decimals: decimals }));
                            usedBalances.push(new bignumber_1.BigNumber(usedBalance));
                        }
                        poolAmountOut = bmath_1.bnum(poolTokensToMint);
                        amounts = bmath_1.calcAllInGivenPoolOut(usedBalances, this.pool.totalSupply, poolAmountOut);
                        return [2 /*return*/, amounts.reduce(function (arr, amount, i) { return __spreadArrays(arr, [
                                __assign(__assign(__assign({}, partials[i]), { amount: bignumber_1.toHex(amount), displayAmount: bignumber_1.formatBalance(amount, partials[i].decimals, 4) }), (_this.getUserTokenData(partials[i].address, amount)))
                            ]); }, [])];
                }
            });
        });
    };
    /**
     * Calculate the amount of a specific token that can be withdrawn by burning a given amount of pool tokens.
     *
     * @param address Address of the token to withdraw
     * @param poolTokensToBurn Amount of pool tokens to burn
     */
    PoolHelper.prototype.calcSingleOutGivenPoolIn = function (address, poolTokensToBurn) {
        return __awaiter(this, void 0, void 0, function () {
            var token, amountOut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        token = this.getTokenByAddress(address);
                        if (!token.ready) {
                            throw Error("Can not exit into token which is not initialized.");
                        }
                        amountOut = bmath_1.calcSingleOutGivenPoolIn(token.balance, token.denorm, this.pool.totalSupply, this.pool.totalWeight, bmath_1.bnum(poolTokensToBurn), this.pool.swapFee, this.pool.exitFee);
                        return [2 /*return*/, {
                                address: address,
                                amount: bignumber_1.toHex(amountOut),
                                symbol: token.symbol,
                                displayAmount: bignumber_1.formatBalance(amountOut, token.decimals, 4),
                                decimals: token.decimals,
                            }];
                }
            });
        });
    };
    /**
     * Calculate the amount of pool tokens that would need to be burned to withdraw a given amount of a token.
     *
     * @param address Address of the token to withdraw
     * @param tokenAmountOut Amount of tokens to get out
     */
    PoolHelper.prototype.calcPoolInGivenSingleOut = function (address, tokenAmountOut) {
        return __awaiter(this, void 0, void 0, function () {
            var amountOut, token, poolAmountIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        amountOut = bmath_1.bnum(tokenAmountOut);
                        token = this.getTokenByAddress(address);
                        if (!token.ready) {
                            throw Error("Can not exit into token which is not initialized.");
                        }
                        poolAmountIn = bmath_1.calcPoolInGivenSingleOut(token.balance, token.denorm, this.pool.totalSupply, this.pool.totalWeight, amountOut, this.pool.swapFee, this.pool.exitFee);
                        return [2 /*return*/, {
                                address: address,
                                amount: bignumber_1.toHex(poolAmountIn),
                                symbol: token.symbol,
                                displayAmount: bignumber_1.formatBalance(poolAmountIn, token.decimals, 4),
                                decimals: token.decimals
                            }];
                }
            });
        });
    };
    /**
     * Calculate the amount of each underlying token that can be withdrawn by burning a given amount of pool tokens.
     *
     * @param poolTokensToBurn Number of pool tokens to burn
     */
    PoolHelper.prototype.calcAllOutGivenPoolIn = function (poolTokensToBurn) {
        return __awaiter(this, void 0, void 0, function () {
            var balances, denorms, partials, _i, _a, token, symbol, address, decimals, balance, denorm, poolAmountOut, amounts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _b.sent();
                        balances = [];
                        denorms = [];
                        partials = [];
                        for (_i = 0, _a = this.tokens; _i < _a.length; _i++) {
                            token = _a[_i];
                            symbol = token.symbol, address = token.address, decimals = token.decimals, balance = token.balance, denorm = token.denorm;
                            partials.push(Object.assign({}, { symbol: symbol, address: address, decimals: decimals }));
                            balances.push(new bignumber_1.BigNumber(balance));
                            denorms.push(new bignumber_1.BigNumber(denorm));
                        }
                        poolAmountOut = bmath_1.bnum(poolTokensToBurn);
                        amounts = bmath_1.calcAllOutGivenPoolIn(balances, denorms, this.pool.totalSupply, poolAmountOut, this.pool.exitFee);
                        return [2 /*return*/, amounts.reduce(function (arr, amount, i) { return __spreadArrays(arr, [
                                __assign(__assign({}, partials[i]), { amount: bignumber_1.toHex(amount), displayAmount: bignumber_1.formatBalance(amount, partials[i].decimals, 4) })
                            ]); }, [])];
                }
            });
        });
    };
    PoolHelper.prototype.calcSpotPrice = function (tokenIn_, tokenOut_) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, tokenOut, realToMinRatio, weightPremium;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokenIn = this.getTokenByAddress(tokenIn_);
                        tokenOut = this.getTokenByAddress(tokenOut_);
                        if (!tokenIn.ready) {
                            realToMinRatio = bmath_1.bdiv(tokenIn.usedBalance.minus(tokenIn.balance), tokenIn.minimumBalance);
                            weightPremium = bmath_1.bmul(bmath_1.MIN_WEIGHT.div(10), realToMinRatio);
                            tokenIn.usedDenorm = bmath_1.MIN_WEIGHT.plus(weightPremium);
                        }
                        return [2 /*return*/, bmath_1.calcSpotPrice(tokenIn.balance, tokenIn.usedDenorm, tokenOut.balance, tokenOut.usedDenorm, this.pool.swapFee)];
                }
            });
        });
    };
    PoolHelper.prototype.calcOutGivenIn = function (tokenIn_, tokenOut_, amountIn) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, tokenOut, realToMinRatio, weightPremium, amountOut, symbol, address, decimals, spotPriceAfter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokenIn = this.getTokenByAddress(tokenIn_);
                        tokenOut = this.getTokenByAddress(tokenOut_);
                        if (!tokenIn.ready) {
                            realToMinRatio = bmath_1.bdiv(tokenIn.usedBalance.minus(tokenIn.balance), tokenIn.minimumBalance);
                            weightPremium = bmath_1.bmul(bmath_1.MIN_WEIGHT.div(10), realToMinRatio);
                            tokenIn.usedDenorm = bmath_1.MIN_WEIGHT.plus(weightPremium);
                        }
                        amountOut = bmath_1.calcOutGivenIn(tokenIn.usedBalance, tokenIn.usedDenorm, tokenOut.balance, tokenOut.denorm, bmath_1.bnum(amountIn), this.pool.swapFee);
                        symbol = tokenOut.symbol, address = tokenOut.address, decimals = tokenOut.decimals;
                        spotPriceAfter = bmath_1.calcSpotPrice(tokenIn.usedBalance.plus(bmath_1.bnum(amountIn)), tokenIn.usedDenorm, tokenOut.usedBalance.minus(amountOut), tokenOut.usedDenorm, this.pool.swapFee);
                        return [2 /*return*/, {
                                symbol: symbol,
                                address: address,
                                decimals: decimals,
                                amount: bignumber_1.toHex(amountOut),
                                displayAmount: bignumber_1.formatBalance(amountOut, decimals, 4),
                                spotPriceAfter: spotPriceAfter
                            }];
                }
            });
        });
    };
    PoolHelper.prototype.calcInGivenOut = function (tokenIn_, tokenOut_, amountOut) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, realToMinRatio, weightPremium, tokenOut, amountIn, symbol, address, decimals, spotPriceAfter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.shouldUpdate) {
                            this.waitForUpdate = this.update();
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        tokenIn = __assign({}, this.getTokenByAddress(tokenIn_));
                        if (!tokenIn.ready) {
                            realToMinRatio = bmath_1.bdiv(tokenIn.usedBalance.minus(tokenIn.balance), tokenIn.minimumBalance);
                            weightPremium = bmath_1.bmul(bmath_1.MIN_WEIGHT.div(10), realToMinRatio);
                            tokenIn.usedDenorm = bmath_1.MIN_WEIGHT.plus(weightPremium);
                        }
                        tokenOut = this.getTokenByAddress(tokenOut_);
                        amountIn = bmath_1.calcInGivenOut(tokenIn.usedBalance, tokenIn.usedDenorm, tokenOut.balance, tokenOut.denorm, bmath_1.bnum(amountOut), this.pool.swapFee);
                        symbol = tokenIn.symbol, address = tokenIn.address, decimals = tokenIn.decimals;
                        spotPriceAfter = bmath_1.calcSpotPrice(tokenIn.usedBalance.plus(amountIn), tokenIn.usedDenorm, tokenOut.usedBalance.minus(bmath_1.bnum(amountOut)), tokenOut.usedDenorm, this.pool.swapFee);
                        return [2 /*return*/, {
                                symbol: symbol,
                                address: address,
                                decimals: decimals,
                                amount: bignumber_1.toHex(amountIn),
                                displayAmount: bignumber_1.formatBalance(amountIn, decimals, 4),
                                spotPriceAfter: spotPriceAfter
                            }];
                }
            });
        });
    };
    return PoolHelper;
}());
exports.PoolHelper = PoolHelper;
